import { render, staticRenderFns } from "./WhPopupSelect.vue?vue&type=template&id=60045418&scoped=true&"
import script from "./WhPopupSelect.vue?vue&type=script&lang=js&"
export * from "./WhPopupSelect.vue?vue&type=script&lang=js&"
import style0 from "./WhPopupSelect.vue?vue&type=style&index=0&id=60045418&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60045418",
  null
  
)

export default component.exports